import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import HomePage from '../pages/HomePage';
import RecursosPage from '../pages/RecursosPage';
import EnlacesPage from '../pages/EnlacesPage';
import JuegaConFortiPage from '../pages/JuegaConFortiPage';
import { conectadosRoutes } from '../features/conectados';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '',
        element: <HomePage />
      },
      {
        path: 'recursos',
        element: <RecursosPage />
      },
      {
        path: 'enlaces',
        element: <EnlacesPage />
      },
      {
        path: 'juegaconforti',
        element: <JuegaConFortiPage />
      },
      ...conectadosRoutes
    ]
  }
]); 